export default function printReportGeneral(name, type, startDate, endDate, columnsJson, finishing, ...params) {
  const token = localStorage.getItem("token");
  const actions = {
    allSales: printSalesPerType,
    daily: printSalesPerDay,
    salePerComposition: printSalesPerComposition,
    client: printSalesPerClient,
    employee: printSalesPerEmployee,
    allBills: printBillsPerType,
    safes: printSafes,
    notes: printNotes,
    notesOp: printNotesOp,
    nfse: printNfse,
    os: printNfse,
    purchase: printPurchase,
    purchaseProducts: printProductsPurchase,
    bestSellers: bestSellers,
    details: details,
    naoVendidosNosUltimos90Dias: naoVendidosNosUltimos90Dias,
  };

  if (actions[name]) {
    actions[name](token, name, type, startDate, endDate, columnsJson, finishing, ...params);
  } else {
    console.log("invalid name");
  }
}

function printSalesPerType(token, name, type, startDate, endDate, columnsJson, finishing) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/gerar/relatorio/geral/todas/vendas/por/periodo/group/A4/?auth=${token}&name=${name}&type=${type}&startDate=${startDate}&endDate=${endDate}&columns=${columnsJson}&finishing=${finishing}`
  );
}
function printSalesPerDay(token, name, type, startDate, endDate, columnsJson, finishing) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/gerar/relatorio/geral/todas/vendas/por/periodo/group/A4/?auth=${token}&name=${name}&type=${type}&startDate=${startDate}&endDate=${endDate}&columns=${columnsJson}&finishing=${finishing}`
  );
}
function printSalesPerComposition(token, name, type, startDate, endDate, columnsJson, finishing) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/gerar/relatorio/geral/todas/vendas/por/periodo/group/A4/?auth=${token}&name=${name}&type=${type}&startDate=${startDate}&endDate=${endDate}&columns=${columnsJson}&finishing=${finishing}`
  );
}
function printSalesPerClient(token, name, type, startDate, endDate, columnsJson, finishing) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/gerar/relatorio/geral/todas/vendas/por/periodo/group/A4/?auth=${token}&name=${name}&type=${type}&startDate=${startDate}&endDate=${endDate}&columns=${columnsJson}&finishing=${finishing}`
  );
}
function printSalesPerEmployee(token, name, type, startDate, endDate, columnsJson, finishing) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/gerar/relatorio/geral/todas/vendas/por/periodo/group/A4/?auth=${token}&name=${name}&type=${type}&startDate=${startDate}&endDate=${endDate}&columns=${columnsJson}&finishing=${finishing}`
  );
}
function printBillsPerType(token, name, type, startDate, endDate) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/bills/print/report/find/all/account/or/find/per/type/bill/?auth=${token}&name=${name}&type=${type}&startDate=${startDate}&endDate=${endDate}`
  );
}
function printSafes(token, name, type, startDate, endDate) {
  console.log('arguments',token, name, type, startDate, endDate)
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/safe/print/report/find/all/safes/?auth=${token}&name=${name}&type=${type}&startDate=${startDate}&endDate=${endDate}&showMovimentOpeningCash=${true}`
  );
}
function printNotes(token, name, type, startDate, endDate) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/nota/print/report/all/notes/or/per/model/?auth=${token}&name=${name}&type=${type}&startDate=${startDate}&endDate=${endDate}`
  );
}

function printNotesOp(token, name, type, startDate, endDate) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/nota/print/report/all/notes/or/per/nature/the/operation/?auth=${token}&name=${name}&type=${type}&startDate=${startDate}&endDate=${endDate}`
  );
}
function printNfse(token, name, _, startDate, endDate) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/nfse/print/report/find/all/nfse/?auth=${token}&model=${name}&startDate=${startDate}&endDate=${endDate}`
  );
}
function printPurchase(token, name, _, startDate, endDate) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/purchase/print/report/find/all/purchase/?auth=${token}&name=${name}&startDate=${startDate}&endDate=${endDate}`
  );
}
function printProductsPurchase(token, name, _, startDate, endDate) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/purchase/print/report/find/all/products/purchase/?auth=${token}&name=${name}&startDate=${startDate}&endDate=${endDate}`
  );
}
function bestSellers(token, name, type, startDate, endDate) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/generate/report/best/sellers?auth=${token}&type=${type}&startDate=${startDate}&endDate=${endDate}`
  );
}
function details(token, name, type, startDate, endDate) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/gerar/relatorio/geral/todas/vendas/por/periodo/group/A4/details?auth=${token}&type=${type}&startDate=${startDate}&endDate=${endDate}`
  );
}

function naoVendidosNosUltimos90Dias(token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/report/least/sold?auth=${token}`
  );
}